import { Box, Typography } from "@mui/material";

export default function Footer() {
    const year = new Date().getFullYear();
    return (
        <Box sx={{ pt: 3, width: "100%", display: "flex", justifyContent: "center", py: 2 }}>
            <Typography variant="body2" color="text.secondary">
                &copy; {year} All content is owned by Federico Torcini
            </Typography>
        </Box>
    );
}
